<template>
  <el-col :span="12">
    <div class="flexbox">
      <form-item
        :label="$t('Integrations_Text_UseStaticIP')"
        :description="$t('Integrations_Text_UseStaticIP_Desc')"
      >
        <feature-toggle v-model="inputVal" />
      </form-item>
      <form-item class="p-left-40" v-if="inputVal && !hasProxyExternalIps">
        <el-link
          href="https://docs.xtremepush.com/docs/ips"
          target="_blank"
          :underline="false"
        >
          <el-button type="primary" plain icon="el-icon-notebook-2">
            {{ $t('Integrations_Text_StaticIPDoc') }}
          </el-button>
        </el-link>
      </form-item>
    </div>
    <el-col :span="18" v-if="inputVal && hasProxyExternalIps">
      <form-item>
        <el-input :value="getProxyExternalIps" :disabled="true" />
        <icon
          glyph="documents"
          size="20"
          style="cursor: pointer;"
          @click="copyToClipboard(getProxyExternalIps)"
        />
      </form-item>
    </el-col>
  </el-col>
</template>

<script>
import FormItem from '@/common/components/form/FormItem.vue'
import FeatureToggle from '@/common/components/form/FeatureToggle.vue'
import store from '@/core/store'

export default {
  name: 'IntegrationProxySettings',

  props: ['value'],

  components: {
    FormItem,
    FeatureToggle
  },

  data() {
    return {}
  },

  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

    hasProxyExternalIps() {
      let externalIps = store.state.app.proxy
        ? store.state.app.proxy['externalIps']
        : null
      return externalIps && externalIps.length
    },
    getProxyExternalIps() {
      let externalIps = store.state.app.proxy
        ? store.state.app.proxy['externalIps']
        : null
      return externalIps ? externalIps.join(', ') : null
    }
  },

  methods: {
    copyToClipboard(value) {
      navigator.clipboard
        .writeText(value)
        .then(_ =>
          this.$message({
            message: this.$t('Integrations_Text_StaticIPCopiedSuccessfully'),
            type: 'success'
          })
        )
        .catch(_ =>
          this.$message.error(
            this.$t('Integrations_Text_StaticIPCopiedUnsuccessfully')
          )
        )
    }
  }
}
</script>
<style scoped>
.flexbox {
  display: flex;
  align-items: flex-end;
}
.el-form-item__content .icon {
  position: absolute;
  padding: 10px;
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/components/IntegrationProxySettings.vue